// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
    GetPagesByPageIdData,
    GetPagesByPageIdErrors,
    GetPagesByPageIdResponses,
    GetStylesData,
    GetStylesErrors,
    GetStylesResponses,
    GetTemplatesByProductGroupCodeData,
    GetTemplatesByProductGroupCodeErrors,
    GetTemplatesByProductGroupCodeResponses,
    GetThemeData,
    GetThemeErrors,
    GetThemeResponses,
    PostManagementConnectorsData,
    PostManagementConnectorsErrors,
    PostManagementConnectorsResponses,
    PostManagementCustomStylingManageData,
    PostManagementCustomStylingManageErrors,
    PostManagementCustomStylingManageResponses,
    PostManagementCustomStylingTenantData,
    PostManagementCustomStylingTenantErrors,
    PostManagementCustomStylingTenantResponses,
    PostManagementStylesManageData,
    PostManagementStylesManageErrors,
    PostManagementStylesManageResponses,
    PostManagementStylesTenantData,
    PostManagementStylesTenantErrors,
    PostManagementStylesTenantResponses,
    PostManagementStylesTokenConstraintsData,
    PostManagementStylesTokenConstraintsErrors,
    PostManagementStylesTokenConstraintsResponses,
    PostManagementTenantsConnectorsData,
    PostManagementTenantsConnectorsErrors,
    PostManagementTenantsConnectorsResponses,
    PostManagementTenantThemesData,
    PostManagementTenantThemesErrors,
    PostManagementTenantThemesResponses,
    PostManagementThemesData,
    PostManagementThemesErrors,
    PostManagementThemesResponses,
} from "./types.gen";

export type Options<
    TData extends TDataShape = TDataShape,
    ThrowOnError extends boolean = boolean,
    TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const postManagementConnectors = <ThrowOnError extends boolean = true>(
    options?: Options<PostManagementConnectorsData, ThrowOnError>
) =>
    (options?.client ?? client).post<PostManagementConnectorsResponses, PostManagementConnectorsErrors, ThrowOnError>({
        security: [{ scheme: "bearer", type: "http" }],
        url: "/management/connectors",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

export const postManagementTenantsConnectors = <ThrowOnError extends boolean = true>(
    options?: Options<PostManagementTenantsConnectorsData, ThrowOnError>
) =>
    (options?.client ?? client).post<
        PostManagementTenantsConnectorsResponses,
        PostManagementTenantsConnectorsErrors,
        ThrowOnError
    >({
        security: [{ scheme: "bearer", type: "http" }],
        url: "/management/tenants/connectors",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Create or update a Manage custom style configuration
 *
 * This will create or update a Manage custom style configuration
 *
 * ### Authorization
 * * Service accounts
 * * Service accounts can create or update a Manage custom style configuration
 *
 * ### Sample requests
 *
 * Create a new Manage custom style configuration
 *
 * POST /management/customStyling/manage
 * {
 * "commonConfiguration":
 * {
 * "disallowedProperties":[
 * "position"
 * "float"
 * ]
 * },
 * "customStyles": [
 * {
 * "customStyleKey": "homepage",
 * "name": "home page",
 * "description": "css for home page",
 * "disallowedProperties": [
 * "color"
 * "namespace"
 * ]
 * }]
 * }
 */
export const postManagementCustomStylingManage = <ThrowOnError extends boolean = true>(
    options?: Options<PostManagementCustomStylingManageData, ThrowOnError>
) =>
    (options?.client ?? client).post<
        PostManagementCustomStylingManageResponses,
        PostManagementCustomStylingManageErrors,
        ThrowOnError
    >({
        security: [{ scheme: "bearer", type: "http" }],
        url: "/management/customStyling/manage",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Create or update a tenant custom style configuration
 *
 * This will create or update a tenant custom style configuration
 *
 * ### Authorization
 * * Service accounts
 * * Service accounts can create or update a tenant custom style configuration
 *
 * ### Sample requests
 *
 * Create a new tenant custom style configuration
 *
 * POST /management/customStyling/tenant
 * {
 * "applicationKey": "Global",
 * "customStyles": [
 * {
 * "customStyleKey": "HomeHeader",
 * "value": "a{border:2px;}"
 * ]
 * }]
 * }
 */
export const postManagementCustomStylingTenant = <ThrowOnError extends boolean = true>(
    options?: Options<PostManagementCustomStylingTenantData, ThrowOnError>
) =>
    (options?.client ?? client).post<
        PostManagementCustomStylingTenantResponses,
        PostManagementCustomStylingTenantErrors,
        ThrowOnError
    >({
        security: [{ scheme: "bearer", type: "http" }],
        url: "/management/customStyling/tenant",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * This method will return the corresponding page
 *
 * This will return a specific page based on the pageId
 *
 * ### Authorization
 * * Service accounts
 * * Service accounts can access all pages
 *
 * ### Sample requests
 *
 * Return a specific page
 *
 * Get /Pages/305cc9b8-93a5-4e00-9c2c-928dc6508472
 */
export const getPagesByPageId = <ThrowOnError extends boolean = true>(
    options: Options<GetPagesByPageIdData, ThrowOnError>
) =>
    (options.client ?? client).get<GetPagesByPageIdResponses, GetPagesByPageIdErrors, ThrowOnError>({
        security: [{ scheme: "bearer", type: "http" }],
        url: "/Pages/{pageId}",
        ...options,
    });

/**
 * This method will return the styling for an application key and culture
 *
 * This will return a specific styling based on the applicationKey and lang
 *
 * ### Sample requests
 *
 * Return a specific styling
 *
 * Get /Styles?applicationKey=appKey&lang=fr-CA
 */
export const getStyles = <ThrowOnError extends boolean = true>(options: Options<GetStylesData, ThrowOnError>) =>
    (options.client ?? client).get<GetStylesResponses, GetStylesErrors, ThrowOnError>({
        security: [
            { name: "X-Client-Key", type: "apiKey" },
            { name: "X-Tenant-Name", type: "apiKey" },
        ],
        url: "/Styles",
        ...options,
    });

/**
 * Create or update a style configuration
 *
 * This will create or update a style configuration
 *
 * ### Authorization
 * * Service accounts
 * * Service accounts can create or update a style configuration
 *
 * ### Sample requests
 *
 * Create a new font style configuration
 *
 * POST /management/styles/manage
 * {
 * "fonts": [
 * {
 * "fontKey": "header",
 * "lineHeight": "normal",
 * "family": "Open Sans, sans-serif",
 * "weight": "400",
 * }]
 * }
 */
export const postManagementStylesManage = <ThrowOnError extends boolean = true>(
    options?: Options<PostManagementStylesManageData, ThrowOnError>
) =>
    (options?.client ?? client).post<
        PostManagementStylesManageResponses,
        PostManagementStylesManageErrors,
        ThrowOnError
    >({
        security: [{ scheme: "bearer", type: "http" }],
        url: "/management/styles/manage",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Create a token constraint
 *
 * ### Authorization
 * * Service accounts
 * * Service accounts can create
 *
 * ### Sample requests
 *
 * Create a constraint for a token
 *
 * POST /management/styles/tokenConstraints
 * {
 * "Apply": [
 * {
 * "ratio": "1/3",
 * "tokens"{
 * "color-text-default": [
 * "color-body-background",
 * "color-card-background"
 * ]
 * }
 * }]
 * }
 */
export const postManagementStylesTokenConstraints = <ThrowOnError extends boolean = true>(
    options?: Options<PostManagementStylesTokenConstraintsData, ThrowOnError>
) =>
    (options?.client ?? client).post<
        PostManagementStylesTokenConstraintsResponses,
        PostManagementStylesTokenConstraintsErrors,
        ThrowOnError
    >({
        security: [{ scheme: "bearer", type: "http" }],
        url: "/management/styles/tokenConstraints",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Create or update a tenant style configuration
 *
 * This will create or update a tenant style configuration
 *
 * ### Authorization
 * * Service accounts
 * * Service accounts can create or update a tenant style configuration
 *
 * ### Sample requests
 *
 * Create a new tenant font style configuration
 *
 * POST /management/styles/manage
 * {
 * "applicationKey": "Glocal"
 * "fonts": [
 * {
 * "fontKey": "header",
 * "lineHeight": "normal",
 * "family": "Open Sans, sans-serif",
 * "weight": "400",
 * }]
 * }
 */
export const postManagementStylesTenant = <ThrowOnError extends boolean = true>(
    options?: Options<PostManagementStylesTenantData, ThrowOnError>
) =>
    (options?.client ?? client).post<
        PostManagementStylesTenantResponses,
        PostManagementStylesTenantErrors,
        ThrowOnError
    >({
        security: [{ scheme: "bearer", type: "http" }],
        url: "/management/styles/tenant",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * This method will return the corresponding template for the given productGroupCode - TBD
 *
 * THIS CONTROLLER IS NOT YET IMPLEMENTED.
 */
export const getTemplatesByProductGroupCode = <ThrowOnError extends boolean = true>(
    options: Options<GetTemplatesByProductGroupCodeData, ThrowOnError>
) =>
    (options.client ?? client).get<
        GetTemplatesByProductGroupCodeResponses,
        GetTemplatesByProductGroupCodeErrors,
        ThrowOnError
    >({
        security: [{ scheme: "bearer", type: "http" }],
        url: "/Templates/{productGroupCode}",
        ...options,
    });

/**
 * This method will return default theme or tenant theme
 *
 * ### Sample requests
 *
 * Return a specific styling
 *
 * Get /
 */
export const getTheme = <ThrowOnError extends boolean = true>(options?: Options<GetThemeData, ThrowOnError>) =>
    (options?.client ?? client).get<GetThemeResponses, GetThemeErrors, ThrowOnError>({
        security: [
            { name: "X-Client-Key", type: "apiKey" },
            { name: "X-Tenant-Name", type: "apiKey" },
        ],
        url: "/Theme",
        ...options,
    });

/**
 * Create or update base theme configuration
 */
export const postManagementThemes = <ThrowOnError extends boolean = true>(
    options?: Options<PostManagementThemesData, ThrowOnError>
) =>
    (options?.client ?? client).post<PostManagementThemesResponses, PostManagementThemesErrors, ThrowOnError>({
        security: [{ scheme: "bearer", type: "http" }],
        url: "/management/themes",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

/**
 * Create or update a tenant theme configuration
 */
export const postManagementTenantThemes = <ThrowOnError extends boolean = true>(
    options?: Options<PostManagementTenantThemesData, ThrowOnError>
) =>
    (options?.client ?? client).post<
        PostManagementTenantThemesResponses,
        PostManagementTenantThemesErrors,
        ThrowOnError
    >({
        security: [{ scheme: "bearer", type: "http" }],
        url: "/management/tenant/themes",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
